import { useState } from "react";
import { useContextCampaign } from "src/Contexts/Campaign/ContextCampaign";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";

export const useHttpTableInstancesWhats = () => {
  const { setListInstancesWhats } = useContextCampaign();
  const { handleGetAlert } = useLayoutMainContext();

  const { setQtdRegisters, currentPage, nameSearch } = useConfigPageContext();

  const [loadingTable, setLoadingTable] = useState(false);

  const handleGet = async () => {
    setLoadingTable(true);

    return api
      .get(
        `/instancesWhats?page=${currentPage}&pageSize=${150}&filter=${nameSearch}`
      )
      .then((res) => {
        setListInstancesWhats(res.data.data);
        setQtdRegisters(res.data.meta.total);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoadingTable(false));
  };

  return { handleGet, loadingTable };
};
